import '@tiger/bs-modal/modal.css'; // 还有一个css文件，主要是隐藏空的标题栏
import Modal, { ModalHandler } from '@tiger/bs-modal';
import classlist from 'utils/classlist';
import styles from './style.scss';

export * from '@tiger/bs-modal';

export interface ModalConfigType extends Omit<Parameters<typeof Modal.open>[0], 'size'> {
    // PC端弹窗尺寸
    size?: 'sm' | 'lg';
}

type SelfModalType = typeof Modal & {
    openSlideModal: (
        config: Omit<ModalConfigType, 'component'> & {
            component: (props: ModalHandler) => React.ReactNode;
            responsive?: boolean; // 是否根据屏幕自适应
        }
    ) => ReturnType<typeof Modal.open>;
};

(Modal as SelfModalType).openSlideModal = config => {
    const { component, animation, dialogClassName, responsive, size, centered, containerClassName, ...restProps } =
        config;
    const isSmScreen = window.matchMedia('(max-width: 576px)').matches;

    if (responsive && !isSmScreen) {
        return Modal.open({
            component: ({ close, dismiss }: ModalHandler) => (
                <div className={classlist(styles.container, containerClassName)}>{component({ close, dismiss })}</div>
            ),
            dialogClassName: classlist(styles.modalDialog, dialogClassName, {
                [styles.modalDialogSm]: size === 'sm',
                [styles.modalDialogLg]: size === 'lg'
            }),
            // 仅在PC端使用居中，底部滑入不使用居中
            centered,
            ...restProps
        });
    }

    return Modal.open({
        component: ({ close, dismiss }: ModalHandler) => (
            <div className={classlist(styles.container, containerClassName)}>{component({ close, dismiss })}</div>
        ),
        animation: 'slide',
        dialogClassName: classlist(styles.slideModalDialog, dialogClassName),
        ...restProps
    });
};

export default Modal as SelfModalType;
